"use client"

import { useOrganization, useUser } from "@clerk/nextjs"
import { usePathname } from "next/navigation"
import Script from "next/script"
import { ReactNode, useEffect } from "react"

const prepareUser = (
  user: ReturnType<typeof useUser>["user"],
  organization: ReturnType<typeof useOrganization>["organization"],
) => {
  if (!user) return {}
  return {
    user_id: user.id,
    name: user.fullName,
    email: user.primaryEmailAddress?.emailAddress,
    created_at: user.createdAt,
    organization: organization?.name,
  }
}

export const Intercom = ({ children }: { children: ReactNode }) => {
  const pathname = usePathname()
  const { user } = useUser()
  const { organization } = useOrganization()

  useEffect(() => {
    window.Intercom?.("update", prepareUser(user, organization))
  }, [pathname, user, organization])

  return (
    <>
      <Script
        src="https://widget.intercom.io/widget/jn10zwoi"
        strategy="lazyOnload"
        onLoad={() => {
          window.Intercom?.("reattach_activator")
          window.Intercom?.("boot", {
            ...prepareUser(user, organization),
            api_base: "https://api-iam.intercom.io",
            app_id: "xwsp8d7i",
          })
        }}
      />
      {children}
    </>
  )
}
